import TermsAndConditions from "@/components/pages/TermsAndConditions";
import Unsubscribe from "@/components/pages/Unsubscribe";

import * as pages from "./../pageNameConstants";

export default [
  {
    path: "/terms-and-conditions",
    name: pages.TERMS_AND_CONDITION,
    component: TermsAndConditions
  },
  {
    path: "/unsubscribe/:id",
    name: pages.UNSUBSCRIBE,
    component: Unsubscribe
  }
];
